import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { MarketNamingTemplateFieldsFragmentDoc } from '../../../fragments/marketNamingTemplateFields.generated';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import { KeywordTagFieldsFragmentDoc } from '../../../fragments/keywordTagFields.generated';
import { HistoryFieldsFragmentDoc } from '../../../fragments/historyFields.generated';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { FieldsToSelectRegDocInDocFormFragmentDoc } from '../../../fragments/fieldsToSelectRegDocInDocForm.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationQueryVariables = Types.Exact<{
  regulationId: Types.Scalars['ID'];
}>;


export type GetRegulationQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, anonymous: boolean, name: string, summary: string, hidden: boolean, source?: string | null, createdAt?: any | null, modifiedAt?: any | null, markets: Array<{ __typename?: 'Market', id: string, name: string, regulationNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }>, regulatoryDocumentNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }> }>, contactPersons: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, regulationClusters: Array<{ __typename?: 'RegulationCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string, givenName?: string | null, mail?: string | null, surname?: string | null, userPrincipalName?: string | null }>, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, icsCodes: Array<{ __typename?: 'IcsCode', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, regulationClusters: Array<{ __typename?: 'RegulationCluster', id: string, name: string }>, auditLog: Array<{ __typename: 'AuditLog', entityId: string, entityNodeId: string, changeSetId: any, entityType: string, entityOperation: Types.EntityOperation, createdAt: any, id: string, entity?: { __typename: 'ActiveTypeMarket', id: string } | { __typename: 'AttachmentCategory', id: string } | { __typename: 'AuditLog', id: string } | { __typename: 'BodyworkVariant', id: string } | { __typename: 'Category', id: string } | { __typename: 'Convolute', id: string } | { __typename: 'Country', id: string } | { __typename: 'DocumentSource', id: string } | { __typename: 'DriveVariant', id: string } | { __typename: 'EngineVariant', id: string } | { __typename: 'GdprRule', id: string } | { __typename: 'GearboxVariant', id: string } | { __typename: 'GetexRegulation', id: string } | { __typename: 'GlobalAnnouncement', id: string } | { __typename: 'IcsCode', id: string } | { __typename: 'Keyword', id: string } | { __typename: 'Market', id: string } | { __typename: 'PermissionGroup', id: string } | { __typename: 'PogisDocument', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionCategory', id: string } | { __typename: 'Reference', id: string } | { __typename: 'Regulation', id: string } | { __typename: 'RegulationCluster', id: string } | { __typename: 'RegulatoryDocument', id: string } | { __typename: 'Requirement', id: string } | { __typename: 'Simulation', id: string } | { __typename: 'SimulationVehicleProject', id: string } | { __typename: 'StandardPlusPcmsCluster', id: string } | { __typename: 'Subscription', id: string } | { __typename: 'SystemLevel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'User', id: string } | { __typename: 'VehicleCategory', id: string } | { __typename: 'VehicleProject', id: string } | { __typename: 'VexCluster', id: string } | { __typename: 'Vko', id: string } | null, change: { __typename: 'AuditLogChange', value?: any | null, oldValue?: any | null, nodeId?: string | null, oldNodeId?: string | null, type: string, key: string, path: string, valueType?: string | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', createdAt?: any | null, modifiedAt?: any | null, pogisExists: boolean, status: Types.RegulatoryDocumentStatus, summary?: string | null, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, documentStatus: Types.DocumentStatus, documentError?: string | null, modelYear?: number | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, dateEffective?: any | null, dateExpiration?: any | null, id: string, name: string, pogisDocuments: Array<{ __typename?: 'PogisDocument', associations?: Array<string> | null, docStatus: string, editor: string, id: string, keywords: Array<string>, linkVersion?: string | null, markets: Array<string>, modifiedAt?: any | null, pogisId: string, regulationStatus: string, relatedDocuments?: Array<string> | null, shortInfo: string, standards?: Array<string> | null, pogisAttachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', fileName: string, uri: any }, category?: { __typename?: 'AttachmentCategory', name: string } | null }> | null, dates: Array<{ __typename?: 'PogisDate', date: any, dateType: string }> }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, message?: string | null, reapprovingVKO: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }, finalVersionRef?: { __typename?: 'RegulatoryDocument', id: string } | null, childrenRefs?: Array<{ __typename?: 'RegulatoryDocument', id: string }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, documentReferences?: Array<{ __typename?: 'DocumentReference', documentReferenceGroup: { __typename?: 'ReferenceGroup', regulatoryDocumentReferences?: Array<{ __typename?: 'RegulatoryDocument', regulation?: { __typename?: 'Regulation', id: string } | null } | null> | null }, referencedByDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string }> }> | null, regulation?: { __typename?: 'Regulation', id: string, isMachineRegulation: boolean } | null }> } | null };


export const GetRegulationDocument = gql`
    query GetRegulation($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    regulationNumber
    anonymous
    name
    summary
    hidden
    source
    markets {
      id
      name
      ...MarketNamingTemplateFields
    }
    contactPersons {
      ...UserFields
    }
    mainKeywords {
      ...KeywordTagFields
    }
    comments {
      id
      comment
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedAt
      modifiedBy {
        ...UserFields
      }
    }
    keywords {
      ...KeywordTagFields
      regulationClusters {
        id
        name
      }
      vkos {
        ...UserFields
      }
      descriptions {
        lang
        translation
      }
    }
    standardPlusPcmsClusters {
      id
      name
    }
    icsCodes {
      id
      name
    }
    createdAt
    modifiedAt
    createdBy {
      ...UserFields
    }
    modifiedBy {
      ...UserFields
    }
    vehicleCategories {
      id
      name
    }
    driveVariants {
      id
      name
    }
    regulationClusters {
      id
      name
    }
    auditLog {
      ...HistoryFields
    }
    attachments {
      ...AttachmentFields
    }
    regulatoryDocuments {
      ...FieldsToSelectRegDocInDocForm
      createdAt
      modifiedAt
      pogisExists
      pogisDocuments {
        associations
        docStatus
        editor
        id
        keywords
        linkVersion
        markets
        modifiedAt
        pogisId
        regulationStatus
        relatedDocuments
        shortInfo
        standards
        pogisAttachments {
          file {
            fileName
            uri
          }
          attachmentId
          category {
            name
          }
        }
        dates {
          date
          dateType
        }
      }
      status
      summary
      disassemblyStatus
      workflow {
        status
        message
        reapprovingVKO {
          ...UserFields
        }
      }
      finalVersionRef {
        id
      }
      childrenRefs {
        id
      }
      documentStatus
      documentError
      attachments {
        ...AttachmentFields
      }
      keywords {
        ...KeywordTagFields
        descriptions {
          lang
          translation
        }
      }
      modelYear
      dateNewRegistration
      dateNewTypes
      dateEffective
      dateExpiration
      phaseIn {
        date
        status
      }
      phaseOut {
        date
        status
      }
      documentReferences {
        documentReferenceGroup {
          regulatoryDocumentReferences {
            regulation {
              id
            }
          }
        }
        referencedByDocuments {
          id
        }
      }
      regulation {
        id
        isMachineRegulation
      }
    }
  }
}
    ${MarketNamingTemplateFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${HistoryFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}
${FieldsToSelectRegDocInDocFormFragmentDoc}`;

/**
 * __useGetRegulationQuery__
 *
 * To run a query within a React component, call `useGetRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetRegulationQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
      }
export function useGetRegulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationQuery, GetRegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationQuery, GetRegulationQueryVariables>(GetRegulationDocument, options);
        }
export type GetRegulationQueryHookResult = ReturnType<typeof useGetRegulationQuery>;
export type GetRegulationLazyQueryHookResult = ReturnType<typeof useGetRegulationLazyQuery>;
export type GetRegulationQueryResult = Apollo.QueryResult<GetRegulationQuery, GetRegulationQueryVariables>;